import type { PrintProduct } from "@/types/PrintProduct";

const BASE = process.env.PUBLIC_URL;

export const PRINT_PRODUCTS: PrintProduct[] = [
    {
        
        id: "none",
        name: "No Overlay",
        overlayFamily: null,
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/no-overlay-horizontal.png`,
                overlayFile: "",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/no-overlay-vertical.png`,
                overlayFile: "",
            },
            square: {
                thumbnail: `${BASE}/thumbnails/PR/no-overlay-square.png`,
                overlayFile: "",
            },
        },
    
    },

    {
        id: "white-border",
        name: "White Border",
        overlayFamily: "white-border",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/white-border-horizontal.png`,
                overlayFile: "white-border-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/white-border-vertical.png`,
                overlayFile: "white-border-vertical.png",
            },
         
        },
    },
    {
        id: "black-border",
        name: "Black Border",
        overlayFamily: "black-border",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/black-border-horizontal.png`,
                overlayFile: "black-border-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/black-border-vertical.png`,
                overlayFile: "black-border-vertical.png",
            },
       
        },
    },

    {
        id: "distressed-white",
        name: "Distressed White",
        overlayFamily: "distressed-white",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/distressed-white-horizontal.png`,
                overlayFile: "distressed-white-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/distressed-white-vertical.png`,
                overlayFile: "distressed-white-vertical.png",
            },
            square: {
                thumbnail: `${BASE}/thumbnails/PR/distressed-white-square.png`,
                overlayFile: "distressed-white-square.png",
            },
        },
    },

    {
        id: "distressed-black",
        name: "Distressed Black",
        overlayFamily: "distressed-black",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/distressed-black-horizontal.png`,
                overlayFile: "distressed-black-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/distressed-black-vertical.png`,
                overlayFile: "distressed-black-vertical.png",
            },
            square: {
                thumbnail: `${BASE}/thumbnails/PR/distressed-black-square.png`,
                overlayFile: "distressed-black-square.png",
            },
        },
    },
   
    {
        id: "boudoir-white",
        name: "Boudoir White",
        overlayFamily: "boudoir-white",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/boudoir-white-horizontal.png`,
                overlayFile: "boudoir-white-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/boudoir-white-vertical.png`,
                overlayFile: "boudoir-white-vertical.png",
            },
            square: {
                thumbnail: `${BASE}/thumbnails/PR/boudoir-white-square.png`,
                overlayFile: "boudoir-white-square.png",
            },
        },
    },
    {
        id: "boudoir-black",
        name: "Boudoir Black",
        overlayFamily: "boudoir-black",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/boudoir-black-horizontal.png`,
                overlayFile: "boudoir-black-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/boudoir-black-vertical.png`,
                overlayFile: "boudoir-black-vertical.png",
            },
            square: {
                thumbnail: `${BASE}/thumbnails/PR/boudoir-black-square.png`,
                overlayFile: "boudoir-black-square.png",
            },
        },
    },
  
    {
        id: "blurry-white",
        name: "Blurry White",
        overlayFamily: "blurry-white",
        variants: {
            horizontal: {
                thumbnail: `${BASE}/thumbnails/PR/blurry-white-horizontal.png`,
                overlayFile: "blurry-white-horizontal.png",
            },
            vertical: {
                thumbnail: `${BASE}/thumbnails/PR/blurry-white-vertical.png`,
                overlayFile: "blurry-white-vertical.png",
            },
            square: {
                thumbnail: `${BASE}/thumbnails/PR/blurry-white-square.png`,
                overlayFile: "blurry-white-square.png",
            },
        },
    },
];